<template>
<!-- <div><br> -->
<!-- <div style="margin-top:20px; text-align:justify;" v-if="activo==0"> -->
  <div class="columns">
    <div class="column is-9" style="margin-left:10px;">
    
    Exodus México | 03 de Julio de 2022
<br><br>
¿Qué es el Aviso de Privacidad?
<br><br>
Documento a disposición del titular de los datos personales de forma física, electrónica o en cualquier formato generado por el responsable, con el objeto de informarle los propósitos del tratamiento de los mismos a partir del momento en el cual se recaben sus datos personales, para la realización de algún servicio publicado en la plataforma Exodus México.
<br><br>
A través de este documento, se le comunica al titular la información que se recaba respecto de su persona y la finalidad de su obtención, así como la posibilidad de ejercer los derechos de acceso, rectificación, cancelación y oposición (derechos ARCO) y la forma de ejercerlos.
<br><br>
¿Qué son los datos personales?
<br><br>
Cualquier información concerniente a una persona física identificada o identificable.
<br><br>
Aviso de Privacidad
<br><br>
Exodus México, es el responsable del uso, tratamiento y protección de los datos personales recabados a través de los servicios que usted realice por medios físicos o electrónicos; observando los principios de licitud, finalidad, lealtad, consentimiento, calidad, proporcionalidad, información y responsabilidad previstos en la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados; por esta razón, se dan a conocer las siguientes políticas basadas en la normativa vigente aplicable a la protección de datos personales.
<br><br>
Objeto
<br><br>
El presente Aviso de Privacidad, explica cómo se tratan y protegen los datos personales que sean recabados en los sistemas y formatos de Exodus México, dándole la seguridad de que los datos serán almacenados en plataformas seguras y su tratamiento se llevará de conformidad con lo dispuesto en los artículos 16, 18, 21, 22, 25, 26 y 65 de la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados.
<br><br>
¿Para qué fines se recabarán sus datos personales?
<br><br>
Los datos personales que recabamos, los utilizaremos para las siguientes finalidades que son necesarias dentro de las actividades propias de Exodus México:
<br><br>
Verificar y confirmar su identidad, así como la autenticidad de la información que nos proporciona para contar con un registro que permita identificar con precisión quién solicita el servicio.<br>
Acreditar los requisitos necesarios para proveer los servicios que ofrecen los proveedores de Exodus México.
Realizar todos los movimientos con motivo del trámite o servicio que solicita desde el momento en que usted reserva.<br>
Integrar expedientes y bases de datos necesarias para el otorgamiento y operación de los servicios que se contraten, así como las obligaciones que se deriven de los mismos.<br>
Mantener una base histórica con fines estadísticos.
<br><br>
¿Qué datos personales se recabarán?
<br><br>
Para llevar a cabo las finalidades descritas en el presente Aviso de Privacidad y de conformidad con el trámite a realizar, se utilizarán, de manera enunciativa más no limitativa, los siguientes datos personales:
<br><br>
Datos de identificación personal: nombre completo, teléfono (fijo o móvil), correo electrónico, nacionalidad.<br>
Los datos que se recaben a través de los sistemas y formatos, en ningún caso son datos sensibles.
<br><br>
Transferencia de datos personales
<br><br>
Sus datos personales no serán transferidos, difundidos, ni distribuidos, salvo lo señalado en el artículo 22 de la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados o en el caso que exista consentimiento expreso de su parte por medio escrito o por un medio de autenticación similar. Sólo tendrán acceso a esta información el titular de los datos, sus representantes legales y los servidores públicos facultados para ello.
<br><br>
¿Dónde puedo ejercer mis derechos ARCO?
<br><br>
Usted tiene derecho a conocer qué datos personales nos ha proporcionado, para qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal cuando esté incompleta, sea inexacta, inadecuada o excesiva (Rectificación); que se elimine de nuestros registros o bases de datos cuando considere que su tratamiento contraviene lo dispuesto por la ley o porque dejó de ser necesaria para el cumplimiento de la finalidad o finalidades de dicha base (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición). Estos derechos se conocen como derechos ARCO.
<br><br>
Usted podrá ejercer sus derechos ARCO, al tratamiento de los datos personales, mediante un escrito libre dirigido a Exodus México al correo electrónico: exodus@sistemy.mx.
<br><br>
Cambios al Aviso de Privacidad
<br><br>
Derivado de nuevos requerimientos legales, de nuevas disposiciones administrativas o de otra índole, el presente Aviso de Privacidad puede sufrir modificaciones, cambios o actualizaciones; en este sentido, Exodus México, se compromete a mantenerlo informado sobre los cambios que pueda sufrir el presente, a través de su sitio electrónico.

    

    </div>
  </div>
  
  

 

<!-- </div> -->


</template>

<script>

import axios from 'axios';
import qs from 'qs';
import Cors from 'cors';
import moment from 'moment';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'
import { Carousel3d, Slide } from 'vue-carousel-3d';

export default {
  components:{
    DatePick,
    VueClockPicker,
    Carousel3d,
    Slide
  },
  data () {
    return {
      

    }
  },
  created(){
    console.log("terminos",this.$route.path)
    
  },
  computed:{
  },
  methods:{
  },
  mixins: [searchMix]
}
</script>
